let getHead = function(e, headline, className, latLng) {
  return "<div class='map-popup'>" +

  "<div class='popup-head '"+className+"><div class='popup-line'></div><a data-lat=" + latLng.lat+ " data-lng=" + latLng.lng + " href=''><h4>" +
  e.features[0].properties['nuts-3-label'] + ", " +
  e.features[0].properties['nuts-2-label']+ ",<br/> " +
  e.features[0].properties['nuts-0-label']+
    //e.features[0].properties['nuts2-name']+
    "</h4></a><div class='icon " + className + "'>"+
    "</div><h1>"+headline+"</h1>"+
    "</div>"+
    "<div class='popup-body'>";
};

let getValue = function(e, param, addTextAfterValue){
  let val = prettyValue(e.features[0].properties[param]);
  // let val = e.features[0].properties[param];
  if(val != 'no data'){
    return ("<h2>"+ val + addTextAfterValue + "</h2>");
  }else{
    return ("<h2>"+ val+"</h2>");
  }
};

let getName = function(name){return "<p class='bold'>"+ name + "</p>";};
let getParagraph = function(text){return "<p>"+ text + "</p>";};
let getSeparator = function(){return "<div class='sep'></div>";};


let prettyValue = function(n){
  if(n === 9999){
    return 'no data';
  }
  var negative = false;
  if(n<0){
    negative = true;
    n *= -1.0;
  }
  var rx=  /(\d+)(\d{3})/;
  return String(n).replace(/^\d+/, function(w){
    while(rx.test(w)){
      w= w.replace(rx, '$1,$2');
    }
    if(negative){w = "-"+w;}
    return w;
  });
};

export {getHead, getValue, getName, getParagraph, getSeparator, prettyValue};